import React, { useEffect, useState } from "react";
import { InventoryListRow } from "./inventoryListRow";
import { AddView } from "./AddView";
import Excelexport from "../exportReportStuff/Excelexport";
import useToggleScroll from "./useToggleScroll";

export function InventoryList(props) {
  const [items, setItems] = useState([]);
  const [groupedItems, setGroupedItems] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [addView, setAddView] = useState(false);
  const [exportView, setExportView] = useState(false);
  const [formattedItems, setFormattedItems] = useState([]);

  function fetchData() {
    console.log("fetching");
    setSelectedRow(null);
    fetch(
      `https://inventy.redata.se/inventdb/api_inventoryCounts.php?Command=GetData&ID=${props.inventoryID}`,
    )
      .then((response) => response.json())
      .then((data) => {
        setItems(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
        setItems([]); // Set items to an empty array on error
      });
  }

  useToggleScroll([addView]);
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (Array.isArray(items)) {
      const groups = items.reduce((acc, item) => {
        acc[item.BarName] = acc[item.BarName] || [];
        acc[item.BarName].push(item);
        return acc;
      }, {});
      setGroupedItems(groups);
    } else setGroupedItems([]);
  }, [items]);

  function handleRowClick(id) {
    setSelectedRow(id);
  }

  function addItem() {
    setAddView(!addView);
  }

  function renderTableForBar(barName, items) {
    return (
      <div key={barName} style={{ width: "100%", marginBottom: "4vh" }}>
        <h2 style={{ margin: "auto" }}>{barName}</h2>
        <table>
          <thead>
            <tr>
              <th style={{ width: "auto" }}>Namn</th>
              <th>Pris</th>
              <th>Antal</th>
              <th>Värde</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <InventoryListRow
                key={index}
                id={props.inventoryID}
                item={item}
                refresh={fetchData}
                selectedRow={selectedRow}
                setSelectedRow={handleRowClick}
                active={props.active}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  function refresh() {
    props.refresh();
    fetchData();
  }

  function closeCount() {
    if (window.confirm("Vill du stänga inventeringen?")) {
      fetch(
        `https://inventy.redata.se/inventdb/api_inventoryCounts.php?Command=Close&ID=${props.inventoryID}`,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            props.refresh();
          } else if (data.error) {
            // Handle any errors returned from the server
            console.error("Error closing count: ", data.error);
          }
        })
        .catch((error) => {
          // Handle any errors that occur during fetch
          console.error("Error updating count: ", error);
        });
    }
  }

  function deleteCount() {
    if (window.confirm("Vill du radera Inventeringen?")) {
      fetch(
        `https://inventy.redata.se/inventdb/api_inventoryCounts.php?Command=Delete&ID=${props.inventoryID}`,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            props.refresh();
          } else if (data.error) {
            console.error("Error deleting count: ", data.error);
          }
        })
        .catch((error) => {
          console.error("Error with fetch: ", error);
        });
    }
  }
  function processAndFlattenResults(results) {
    // Check if 'results' is not an array or is an empty array
    if (!Array.isArray(results) || results.length === 0) {
      return [
        {
          Kategori: null,
          Underkategori: null,
          Namn: "Inventeringen saknar produkter", // "The inventory lacks products"
          Antal: null,
          Enhetspris: null,
          Värde: null,
        },
      ];
    }

    let inventory = {};

    // Process results into nested object structure
    results.forEach((row) => {
      let {
        ItemGroupName: category,
        ItemSubGroupName: subcategory,
        ProductName: name,
        Quantity: quantity,
        UnitPrice: unitPrice,
      } = row;
      let value = quantity * unitPrice;

      if (!inventory[category]) {
        inventory[category] = {};
      }

      if (!inventory[category][subcategory]) {
        inventory[category][subcategory] = {
          products: [],
          subtotal: 0,
        };
      }

      inventory[category][subcategory].products.push({
        name,
        quantity,
        unitPrice,
        value,
      });
      inventory[category][subcategory].subtotal += value;
    });

    // Convert nested object into structured array
    let structuredInventory = Object.keys(inventory).map((category) => {
      let total = 0;
      let subcategories = Object.keys(inventory[category]).map((subcat) => {
        let subtotal = inventory[category][subcat].subtotal;
        total += subtotal;
        return {
          name: subcat,
          products: inventory[category][subcat].products,
          subtotal,
        };
      });

      return {
        category,
        subcategories,
        total,
      };
    });

    // Flatten the structured inventory for Excel
    let rows = [];
    let grandTotal = 0;

    rows.push({
      Kategori: "Inventering",
      Underkategori: null,
      Namn: null,
      Antal: null,
      Enhetspris: null,
      Värde: null,
    });
    rows.push({
      Kategori: `${props.name} ${props.year}`,
      Underkategori: null,
      Namn: null,
      Antal: null,
      Enhetspris: null,
      Värde: null,
    });
    rows.push({
      Kategori: null,
      Underkategori: null,
      Namn: null,
      Antal: null,
      Enhetspris: null,
      Värde: null,
    });

    const header = {
      Kategori: "Kategori",
      Underkategori: "Underkategori",
      Namn: "Namn",
      Antal: "Antal",
      Enhetspris: "Enhetspris",
      Värde: "Värde",
    };
    rows.push(header);

    structuredInventory.forEach(
      ({ category, subcategories, total: categoryTotal }) => {
        rows.push({
          Kategori: category,
          Underkategori: "",
          Namn: "",
          Antal: "",
          Enhetspris: "",
          Värde: "",
        });

        subcategories.forEach(
          ({ name: subcategoryName, products, subtotal }) => {
            products.forEach((product) => {
              rows.push({
                Kategori: "",
                Underkategori: subcategoryName,
                Namn: product.name,
                Antal: product.quantity,
                Enhetspris: product.unitPrice,
                Värde: product.value,
              });
            });
          },
        );

        rows.push({
          Kategori: "",
          Underkategori: "",
          Namn: "Totalt",
          Antal: "",
          Enhetspris: "",
          Värde: categoryTotal,
        });
        rows.push({
          Kategori: "",
          Underkategori: "",
          Namn: "",
          Antal: "",
          Enhetspris: "",
          Värde: "",
        });

        grandTotal += categoryTotal;
      },
    );

    rows.push({
      Kategori: "",
      Underkategori: "",
      Namn: "",
      Antal: "",
      Enhetspris: "",
      Värde: "",
    });
    rows.push({
      Kategori: "Inventeringsvärde",
      Underkategori: "",
      Namn: "",
      Antal: "",
      Enhetspris: "",
      Värde: grandTotal,
    });

    return rows;
  }

  function makeReport(id) {
    fetch(
      "https://inventy.redata.se/inventdb/api_reportData.php?Command=Select&ID=" +
        id,
    )
      .then((response) => response.json())
      .then((data) => {
        setFormattedItems(processAndFlattenResults(data)); // Update state
        setExportView(!exportView);
      })
      .catch((error) => {
        console.error("Error fetching report data: ", error);
      });
  }

  return (
    <div
      className="Widget"
      style={{
        boxShadow: "4px 5px 11px 1px rgba(0,0,0,0.75)",
        WebkitBoxShadow: "4px 5px 11px 1px rgba(0,0,0,0.75)",
        MozBoxShadow: "4px 5px 11px 1px rgba(0,0,0,0.75)",
        backgroundColor: "var(--background-color)",
      }}
    >
      <h2 className="Title">{props.name}</h2>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          marginBottom: "20px",
        }}
      >
        {props.active ? (
          <>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <button onClick={closeCount} className="Delete">
                Stäng Inventering
              </button>
              <button onClick={() => makeReport(props.inventoryID)}>
                F-Rapport
              </button>
            </div>
            <div>
              <button onClick={addItem}>Lägg till produkt</button>
            </div>
          </>
        ) : (
          <>
            <button onClick={deleteCount} className="Delete">
              Radera Inventering
            </button>
            <button onClick={() => makeReport(props.inventoryID)}>
              Skapa Rapport
            </button>
          </>
        )}

        {addView && (
          <AddView
            setAddView={setAddView}
            refresh={refresh}
            type="InventoryData"
            name={props.name}
            id={props.inventoryID}
          />
        )}

        {exportView && (
          <Excelexport
            excelData={formattedItems}
            fileName={`Rapport-${props.year}:${props.name}`}
            setExportView={setExportView}
          />
        )}
      </div>

      {Object.entries(groupedItems).map(([barName, items]) =>
        renderTableForBar(barName, items),
      )}
    </div>
  );
}
